
export default class SearchFormPosts {

    constructor(){

        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual';
        }

        const body = document.querySelector( 'body' ) ;

        body.addEventListener( 'click', (e ) => { this.blog_search_form__handler( e ); } );
    }


    blog_search_form__handler( e ){

        // console.log('blog_search_form__handler');

        let target_dataset = e.target.dataset ;

        let this_button = e.target.closest('button') ;


        if( this_button != null ) {
            target_dataset = this_button.dataset;
        }


        if( 'search-form-posts-filter' === target_dataset.click ){

            e.preventDefault();
            e.stopPropagation();

            // - -

            if( ( 'reset' === target_dataset.behaviour ) ){

                let url = new URL(window.location);
                url = this.reset_url_filters( url );
                window.history.pushState({}, '', url );
            }
        }


        // - - - - - - - - - - - - - - - - - - - - - - - -


        if( 'search-form-posts-refresh' === target_dataset.click ){

            e.preventDefault();
            e.stopPropagation();

            // - -

            let url = new URL(window.location);
            let form_params = this.get_search_form_params( jQuery( e.target ).closest( 'form.search-form-posts' ) ) ;

            if( ( 'search' === target_dataset.behaviour ) || ( 'filter' === target_dataset.behaviour ) ){


                // console.log( form_params ) ;

                if( this.is_valid_form_params( form_params ) ){

                    url = this.update_url_search( url, form_params );
                    url = this.update_url_filters( url, form_params );

                    window.history.pushState({}, '', url );
                }
            }
        }

        // - - - - - - - - - - - - - - - - - - - - - - - -
    }


    // - - - - - - - - - - - - - - - - - - - - - - - -
    // - - - - - - - - - - - - - - - - - - - - - - - -


    get_search_form_params( $form ){

        let results  = {} ;


        results.blogF = {} ;

        let category = $form.find( '#blog-filter--category input:checked' )  ;


        if( category.length > 0 ){ results.blogF.category = category.first().val() ; }
        else{ results.blogF.category = '' ; }


        // - -

        results.blogO = {} ;

        let order = $form.find( '#blog-filter--order input:checked' )  ;

        if( order.length > 0 ){ results.blogO.order = order.first().val() ; }
        else{ results.blogO.order = '' ; }


        return results ;
    }



    is_valid_form_params( params ){

        return true ;

        // disable location required
        // if( params.blogQ.title != '' ){ return true ; }

        // disable location required
        /*
		if( ( params.blogQ.title != '' ) && ( params.blogQ.location != '' ) ){
			return true ;
		}
		*/

        return false ;
    }




    update_url_search( url, params ){


        // pages & load more reset
        url.searchParams.set('blogP[pages]', '1' );
        try{ url.searchParams.delete('blogP[more]' );  }catch( error ){}

        return url ;

    }

    reset_url_filters( url ){

        // try{ url.searchParams.delete('blogO[order]' );  }catch( error ){}

        try{ url.searchParams.delete('blogF[category]' );  }catch( error ){}
        url.searchParams.set('blogF[category]', '' );

        return url ;

    }


    update_url_filters( url, params ){

        // order
        url.searchParams.set( 'blogO[order]', params.blogO.order );

        // cateogry
        url.searchParams.set( 'blogF[category]', params.blogF.category );


        return url ;

    }



}


